import React, { Component, useEffect, useState } from 'react';
import globalLogoImg from 'Assets/img/global-payments-logo.png';
import './inactivePaperlessForm.scss';
import translation from './inactiveTranslations.json';
import { VITE_MERCHANT_HELP_URL } from 'Constants/appEnvConstants';

const InactivePaperlessForm = ({ history }) => {
  const [language, setLanguage] = useState('eng');
  const [content, setContent] = useState({});
  const [selectedLanguage, setSelectedLanguage] = useState('eng');

  const redirectToHelpCenter = () => {
    window.open(`${VITE_MERCHANT_HELP_URL}`);
  };

  useEffect(() => {
    if (language === 'french') {
      setContent(translation.fc);
    } else if (language === 'eng') {
      setContent(translation.en);
    } else if (language === 'sc') {
      setContent(translation.sc);
    } else if (language === 'tc') {
      setContent(translation.tc);
    } else if (language === 'sp') {
      setContent(translation.sp);
    }
  }, [language]);

  const handleLanguageChange = (e) => {
    setLanguage(e.target.id);
    setSelectedLanguage(e.target.id);
  };

  const languageOptions = [
    { id: 'eng', label: 'English' },
    { id: 'french', label: 'Française' },
    { id: 'sp', label: 'Español' },
    { id: 'sc', label: '简体中文' },
    { id: 'tc', label: '繁體中文' },
  ];

  return (
    <div>
      <img src={globalLogoImg} className="logo" />
      <div className="layout">
        <div className="layout__heading">{content.inactive_heading}</div>
        <br />
        <br />
        <div className="layout__details">{content.inactive_p1}</div>
        <br />
        <div className="layout__details">{content.inactive_p2}</div>
        <button type="button" onClick={redirectToHelpCenter} className="layout__helpButton">
          {content.help_center}
        </button>
        <br />
        <br />
        <div>
          {languageOptions.map((option) => (
            <span
              key={option.id}
              className={`layout__textcolor ${selectedLanguage === option.id ? 'layout__selected' : ''}`}
              id={option.id}
              onClick={handleLanguageChange}
            >
              {option.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InactivePaperlessForm;
